<!DOCTYPE HTML>
<template>
<div class="provider-details"
     v-if="provider">

  <div class="cols">
    <div class="left">
      <CloseButton @close="close" />
      <div>
        <div class="uppercaseheader">Provider</div>
        <!--<h2>{{asFullName(provider.name)}}</h2>-->
        <h2>Undisclosed</h2>
      </div>
      <div>
        <div class="uppercaseheader">Member since</div>
        <p>{{asShortDate(provider.created)}}</p>
      </div>
      <div>
        <div class="uppercaseheader">Biography</div>
        <p>{{bio}}</p>
      </div>
      <div>
        <div class="uppercaseheader">Reviews</div>
        <p class="empty">No reviews yet</p>
      </div>
    </div>

    <b-list-group class="right">

      <b-list-group-item v-if="provider.rate">
        <div class="uppercaseheader">
          Avg hourly rate
        </div>
        <div class="rate">
          {{asHourlyRate(provider.rate)}}
        </div>
      </b-list-group-item>

      <b-list-group-item v-if="provider.experience">
        <div class="uppercaseheader">
          Experience
        </div>
        <div class>
          {{provider.experience}} years
        </div>
      </b-list-group-item>

      <b-list-group-item :variant="skills.variant">
        <div>
          {{ skills.title}}
        </div>
        <div v-if="skills.has">
          <Pillgroup :items="relevantSkills(project, provider)" />
        </div>
      </b-list-group-item>


      <b-list-group-item v-if="!currentStatus(project,provider)">
        <b-button variant="success"
                  @click="changeStatus(project, provider, 'invited')">
          Invite for interview</b-button>
      </b-list-group-item>

      <b-list-group-item v-else
                         variant="warning">
        {{statusAsClient(project, provider)}}
        <b-button variant="outline-light"
                  size="sm"
                  @click="changeStatus(project, provider)">Undo</b-button>
      </b-list-group-item>

    </b-list-group>
  </div>


</div>
</template>

<script>
// Components
import Pillgroup from '@/components/Pillgroup.vue'
import CloseButton from '@/components/CloseButton.vue'
//Mixins
import { Formatter, Skills, Status } from '@/mixins/Mixins.js'
export default {
  name: 'ProviderDetails',
  components: {
    Pillgroup,
    CloseButton,
  },
  mixins: [ Formatter, Skills, Status ],
  props: {
    userData: Object,
    provider: Object,
    project: Object,
  },
  data() {
    return {}
  },
  computed: {
    bio() {
      return this.provider.bio ?
        this.provider.bio : 'Curabitur blandit tempus porttitor. Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum. Nullam id dolor id nibh ultricies vehicula ut id elit.'

    },
    skills() {
      let rel = this.relevantSkills( this.project, this.provider )
      let variant = ''
      let title = `${rel.length} relevant skills`
      let has = true
      if ( rel.length == 0 ) {
        variant = 'danger'
        has = false
      }
      return { variant, title, has }
    }
  },
  methods: {
    close() {
      this.$emit( 'close' )
    },
  }
}
</script>

<style lang="scss">
@import "@/styles/global.scss";
.provider-details {
    .cols {
        display: grid;
        grid-template-columns: 3fr 2fr;
        grid-column-gap: 4rem;
        .left {
            display: grid;
            grid-row-gap: 1rem;
            align-content:: flex-start;

            p {
                font-family: 'Roboto';
                color: theme-color-level('primary',-5);
            }
        }
        .right {
            .list-group-item {
                display: grid;
                grid-row-gap: 0.5rem;

                .label {
                    color: theme-color-level('primary',-5);
                }

                .rate {
                    font-size: 2rem;
                }
            }
        }
    }
}
</style>
